import type { EventListItemDto } from "../../autogen/bff-api";
import { displayPersonName } from "../../common/persons/displayPersonName";
import { type SearchedField, searchHitOutsideShownColumns } from "../../common/entity-table/searchHit";

const SEARCHED_FIELDS: SearchedField<EventListItemDto>[] = [
  { key: "title", values: (event) => [event.title] },
  { key: "internalReference", values: (event) => [event.referenceId] },
  { key: "responsiblePersons", values: (event) => [displayPersonName(event.responsible).trim()] },
];

export const procurementSearchHitOutsideShownColumns = (
  event: EventListItemDto,
  term: string | null | undefined,
  shownColumns: Set<string>,
) => searchHitOutsideShownColumns(SEARCHED_FIELDS, event, term, shownColumns);
